import "./Contact.css";
import { useState } from "react";
import {
  FaEnvelope,
  FaFacebookF,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaGlobe,
} from "react-icons/fa";
import { useForm } from "react-hook-form";
import emailjs from "@emailjs/browser";
// import { Link } from "react-router-dom";
import { toast } from "sonner";
import logger from "../Components/Logger";

export function Contact({ t }) {
  const [msg, setMsg] = useState(""); //Source et exemple trouver sur : https://stackoverflow.com/questions/71730508/displaying-a-sucess-message-using-email-js
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lastSubmissionTime, setLastSubmissionTime] = useState(0);
  const [isCooldown, setIsCooldown] = useState(false);
  //exemple du code prit de la page Admission.jsx
  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      message: "",
      inquiryType: "",
    },
  });
  const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATES_Contact;
  const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const onSubmit = (data) => {
    const now = Date.now(); //aide ia

    // Implementing a simple rate limit of 1 minute between form submissions
    if (now - lastSubmissionTime < 60000) {
      toast.error(
        t.AlertRateLimit ||
          "Veuillez patienter une minute avant de renvoyer un message.",
      );
      logger.warn(
        "User attempted to submit the contact form too quickly. Rate limit enforced.",
      );
      return;
    }
    setIsLoading(true);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //exemple de code trouver sur : https://www.linkedin.com/pulse/removing-html-tags-string-sanitizing-using-javascript-alvison-hunter-edm1e/ , https://www.geeksforgeeks.org/javascript/how-to-strip-out-html-tags-from-a-string-using-javascript/
    const cleanString = (str) => {
      if (typeof str !== "string") return str;
      return str
        .replace(/[<>]/g, "")
        .replace(/[\n\r]/g, " ")
        .trim();
    };

    const CleanData = {
      firstName: cleanString(data.firstName),
      lastName: cleanString(data.lastName),
      email: cleanString(data.email.trim().toLowerCase()),
      message: data.message.trim().replace(/[<>]/g, ""),
      inquiryType: data.inquiryType,
    };

    //exemple trouver sur : www.tempmail.us.com/fr/regex/comprendre-et-resoudre-les-problemes-de-validation-des-e-mails-regex-en-c
    // Validate email format before sending
    if (!emailRegex.test(CleanData.email)) {
      toast.error("Format d'email non supporté ou dangereux.");
      logger.warn("User entered an invalid email format in the contact form.");
      setIsLoading(false);
      return;
    }
    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, CleanData, PUBLIC_KEY)
      .then((res) => {
        //Source et exemple trouver sur : https://stackoverflow.com/questions/71730508/displaying-a-sucess-message-using-email-js
        setIsError(false);
        setLastSubmissionTime(Date.now());
        reset();
        setTimeout(() => setMsg(""), 3000);
        console.log("EmailJS success:", res);
        setIsCooldown(true);
        setTimeout(() => setIsCooldown(false), 60000);

        const translatedTitle =
          document.getElementById("msg-success-title").innerText;
        const translatedDesc =
          document.getElementById("msg-success-desc").innerText;

        // Remplace ton bloc toast.success actuel par celui-ci :
        toast.success(translatedTitle, {
          className: "toast-success",
          description: translatedDesc,
          duration: 5000,
          icon: "🔔",
        });
        logger.info("Form submitted successfully, email sent via EmailJS.");
      })
      .catch((err) => {
        setIsError(true);
        console.error("EmailJS error:", err);
        setMsg(t.AlertError || "Erreur lors de l'envoi.");
        setTimeout(() => setMsg(""), 3000);
        logger.error("Failed to submit form, EmailJS error occurred.");
      })
      .finally(() => {
        setIsLoading(false);
      });
    console.log("Form Data:", data);
  };

  const contactItems = [
  { icon: <FaPhoneAlt className="contact-iconPhone" />, label: t.Phone, value: "(514) 690-6696" },
  { icon: <FaEnvelope className="contact-iconEn" />, label: t.Email, value: "a1tutorial@gmail.com" },
  { icon: <FaMapMarkerAlt className="contact-iconMap" />, label: t.Address, value: `${t.AddressStreet}, ${t.AddressCity}` },
  { icon: <FaGlobe className="contact-iconGlobe" />, label: t.Languages, value: t.LanguagesList },
];

  return (
    <div>
      <main>
        <section className="top-section">
          <div className="info-box">
            <h2 className="section-titlet">{t.ContactInfoTitle}</h2>

            <p className="contact-info-intro"> {t.ContactInfoIntro}</p>

            {contactItems.map((item, index) => (
            <div className="contact-item" key={index}>
              <div className="contact-icon">{item.icon}</div>
              <div className="contact-text">
                <strong>{item.label}</strong>
                <span>{item.value}</span>
              </div>
            </div>
            ))}
            <div className="contact-social-divider">
              <span>{t.FollowUs}</span>
            </div>
            <div className="logo-icons">
              {/* Source : https://mailtrap.io/blog/mailto-links-explained/ */}
              <a
                href="mailto:a1tutorial@gmail.com?subject=Request for information"
                className="icon-link"
              >
                <FaEnvelope />
                <span>{t.Email}</span>
              </a>
              <a
                href="https://www.facebook.com/A1Tutorial/"
                className="icon-link"
              >
                <FaFacebookF />
                <span>Facebook</span>
              </a>
            </div>
          </div>

          <div className="tutoring-box">
            <h2 className="section-titlet">{t.TutoringScheduleTitle}</h2>
            <p className="schedule-note">{t.ScheduleNote}</p>
            <div className="schedule-container">
              <div className="schedule-header">
                <span className="badge-icon">👥</span>
                <strong>{t.GroupTutoring}</strong>
              </div>
              <div className="schedule-days">
                <div className="day-row">
                  <span className="day-text">
                    {t.GroupDaysWeek}
                    <small>({t.Evening})</small>
                  </span>
                  <span className="time">4:30 PM - 7:30 PM</span>
                </div>
                <div className="day-row">
                  <span className="day-text">
                    {t.GroupDaysWeekend}
                    <small>({t.MidDay})</small>
                  </span>
                  <span className="time">11:00 AM - 1:00 PM</span>
                </div>
              </div>
              <hr className="schedule-divider" />
              <div className="schedule-header">
                <span className="badge-icon">👤</span>
                <strong>{t.OneOnOneTutoring}</strong>
              </div>
              <div className="schedule-days">
                <div className="day-row">
                  <span className="day-text">
                    {t.GroupDaysWeekend}
                    <small>({t.Morning})</small>
                  </span>
                  <span className="time">9:00 AM - 11:00 AM</span>
                </div>
                <div className="day-row">
                  <span className="day-text">
                    {t.GroupDaysWeekend}
                    <small>({t.Afternoon})</small>
                  </span>
                  <span className="time">1:00 PM - 3:00 PM</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bottom-section">
          <form className="Cta-form" onSubmit={handleSubmit(onSubmit)}>
            <h2 className="section-titlet">{t.ContactUsFormTitle}</h2>

            {msg && (
              <div className={`simple-msg ${isError ? "error" : "success"}`}>
                {msg}
              </div>
            )}
            {/*aider par gemini pour que le message ne s'affiche tant que rien n'est envoyé et exemple trouver sur : https://stackoverflow.com/questions/50377147/react-conditional-classnames-using-template-strings-and-operator*/}

            <p className="form-legend">
              <span className="required">*</span> {t.RequiredField}
            </p>
            <div className="name-row">
              <div className="form-box">
                <input
                  type="text"
                  placeholder={t.PlaceholderFirstName}
                  {...register("firstName", { required: true })}
                  required
                />
              </div>

              <div className="form-box">
                <input
                  type="text"
                  placeholder={t.PlaceholderLastName}
                  {...register("lastName", { required: true })}
                  required
                />
              </div>
            </div>

            <div className="form-box">
              <input
                type="email"
                placeholder={t.PlaceholderEmail}
                {...register("email", { required: true })}
                required
              />
            </div>

            <div className="form-box">
              <textarea
                rows="4"
                placeholder={t.PlaceholderMessage}
                {...register("message", { required: true })}
                required
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = e.target.scrollHeight + "px";
                }}
              ></textarea>
            </div>

            <div className="form-box">
              <select
                {...register("inquiryType", { required: true })}
                defaultValue=""
                required
              >
                <option value="" disabled>
                  {t.SelectOption}
                </option>
                <option value="Tutoring-Student">{t.OptionStudent}</option>
                <option value="Tutoring-Tutor">{t.OptionTutor}</option>
              </select>
            </div>

            <button type="submit" className={isCooldown ? "btn-cooldown" : ""} disabled={isLoading || isCooldown}>
              {isLoading ? "Sending in progress…" : isCooldown ? t.PleaseWait || "Please wait..." : t.SendMessageBtn}
            </button>
          </form>

          <div className="contact-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2922.624948047944!2d-73.62742592375392!3d45.52541982935195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc9190a2eb76403%3A0xbfea07dbf98f19e5!2sA1%20Tutorial%20Inc!5e1!3m2!1sfr!2sca!4v1775000925498!5m2!1sfr!2sca"
              loading="lazy"
              title="A1 Tutorial Map Location"
              referrerpolicy="no-referrer-when-downgrade"
              allowfullscreen=""
            ></iframe>
          </div>
        </section>
      </main>
      <div style={{ display: "none" }} aria-hidden="true">
        <div id="msg-success-title">{t.ToastFormSucess}</div>
        <div id="msg-success-desc">{t.ToastFormDescription}</div>
      </div>
    </div>
  );
}
